package com.essntl.features.supplier.ui.allsuppliers

import com.essntl.features.supplier.domain.model.SupplierFilterOptions
import com.essntl.features.supplier.domain.model.SupplierModel

interface AllSuppliersEvent {
    data class LoadSuppliers(val supplier: SupplierModel? = null) : AllSuppliersEvent
    data class EditFilterOptions(val filterOptions: SupplierFilterOptions) : AllSuppliersEvent
}